(() => {
  const initGalleryControls = (root = document) => {
    const galleries = [];
    if (root.matches?.('product-gallery')) galleries.push(root);
    if (root.querySelectorAll) galleries.push(...root.querySelectorAll('product-gallery'));

    galleries.forEach((gallery) => {
      if (gallery.dataset.galleryControlsBound === 'true') return;

      const carousel = gallery.querySelector('.product-gallery__carousel');
      if (!carousel || typeof carousel.select !== 'function') {
        window.setTimeout(() => initGalleryControls(gallery), 50);
        return;
      }

      const counter = gallery.querySelector('[data-gallery-counter]');
      const current = counter?.querySelector('[data-gallery-current]');
      const total = counter?.querySelector('[data-gallery-total]');
      const jumpButton = gallery.querySelector('[data-gallery-jump-button]');

      const updateControls = () => {
        const cells = carousel.cells;
        const imageCount = cells.length;
        const currentIndex = imageCount ? Math.min(carousel.selectedIndex + 1, imageCount) : 0;

        if (current && total) {
          current.textContent = String(currentIndex);
          total.textContent = String(imageCount);
          counter.setAttribute('aria-label', `${currentIndex} of ${imageCount} images`);
          counter.hidden = imageCount < 2;
        }

        if (jumpButton) {
          const targetIndex = Number(jumpButton.dataset.galleryTarget);
          jumpButton.hidden = !Number.isInteger(targetIndex) || targetIndex < 1 || targetIndex > imageCount;
        }
      };

      ['carousel:change', 'carousel:settle', 'carousel:filter'].forEach((eventName) => {
        carousel.addEventListener(eventName, updateControls);
      });

      carousel.addEventListener('click', (event) => {
        if (
          window.matchMedia('(min-width: 700px)').matches ||
          !gallery.hasAttribute('allow-zoom') ||
          event.target.tagName !== 'IMG'
        ) return;

        const media = event.target.closest('.product-gallery__media');
        if (!media || media.getAttribute('data-media-type') !== 'image') return;

        const imageCells = carousel.cells.filter((cell) => cell.getAttribute('data-media-type') === 'image');
        const imageIndex = imageCells.indexOf(media);
        if (imageIndex < 0) return;

        gallery.dispatchEvent(new CustomEvent('lightbox:open', {
          bubbles: true,
          detail: { index: imageIndex }
        }));
      });

      jumpButton?.addEventListener('click', () => {
        const targetIndex = Number(jumpButton.dataset.galleryTarget);
        if (Number.isInteger(targetIndex) && targetIndex >= 1 && targetIndex <= carousel.cells.length) {
          carousel.select(targetIndex - 1);
        }
      });

      gallery.dataset.galleryControlsBound = 'true';
      updateControls();
    });
  };

  initGalleryControls();
  document.addEventListener('shopify:section:load', (event) => initGalleryControls(event.target));
})();
